module.exports = __webpack_public_path__ + "4b29dbb88811ac88a82bfbc1bb8ca07f.png";